<script>
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
	props: {
		// mapConfig: Object,
		// apiKey: String
	},

	data() {
		return {
			mapReady: false,
			geocoder: null,
			google: null,
			map: null,
		};
	},

	computed: {
		currentZoom: function () {
			return this.map.zoom;
		},
		currentMapCenter: function () {
			return {
				degrees: {
					lat: this.map.center.lat(),
					lng: this.map.center.lng(),
				},
				dms: {
					lat: this.degreesToDms(this.map.center.lat(), "lat"),
					lng: this.degreesToDms(this.map.center.lng(), "lng"),
				}
			};
		}
	},

	methods: {
		degreesToDms(degreesFloat, direction) {
			var letters = {
				lat: ["N", "S"],
				lng: ["E", "W"],
			};
			var letters = letters[direction];
			var degrees = parseInt(degreesFloat);
			var minutesFloat = (degreesFloat - degrees) * 60;
			var minutes = parseInt(minutesFloat);
			var secondsFloat = (minutesFloat - minutes) * 60;
			var seconds = parseInt(secondsFloat);
			return degrees + "º " + minutes + "' " + seconds + "\" " + (degreesFloat >= 0 ? letters[0] : letters[1]);
		},
		initializeMap() {
			const mapContainer = this.$refs.mapContainer;
			this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
			this.mapReady = true;
		}
	},

	async created() {
		var self = this;
		const googleMapApi = await GoogleMapsApiLoader({
			libraries: ["places", "geocoder"],
			apiKey: window.googleApiKey,
		}).then(function (googleApi) {
			self.google = googleApi;
			self.geocoder = new self.google.maps.Geocoder();
			self.initializeMap();
			self.initialize();
		});
	},

	render() {
	}
};
</script>
